"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPublicHolidaysByCountryAndRegion = void 0;
const getPublicHolidaysByCountryAndRegion = async (supabase, country_id, region_id) => {
    const { data: holidays, error } = await supabase
        .from("public_holidays")
        .select(`*,
        country:country_id(regions!inner(id, name), id, name),
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .eq("country_id", country_id)
        .contains("regions", [region_id])
        .order("start_date", { ascending: true });
    if (error)
        return [];
    return holidays;
};
exports.getPublicHolidaysByCountryAndRegion = getPublicHolidaysByCountryAndRegion;
